import(/* webpackMode: "eager" */ "/deploy-cf/app/global-error.tsx")